import React from 'react'
import PropTypes from 'prop-types'

const setLabel = (stepOneMode) => {
  switch (stepOneMode) {
    default:
      return ''
    case 'add':
      return 'Cadastre um endereço para entrega do cartão'
    case 'edit':
      return 'Selecione um endereço para entrega do cartão'
  }
}

const Header = ({ step, handleStep, handleStepOnMode, stepOnMode, address }) => {
  return (
    <div className='col-12 '>
      <div className='checkout-step-address checkout-step row px-2 border-bottom border-top border-color-ui-3 '>
        <div className='col-auto px-1'>
          <div className='row mx-0 align-items-center h-100'>
            <i className={`icon icon_truck ${step === 1 ? ' color-brand-2-like' : 'color-ui-3'}`} aria-hidden='true' />
          </div>
        </div>
        <div className='col py-1'>
          { step === 1
            ? <div className='row mx-0 align-items-center h-100'>
              <div className='p-0 col-md-10 col-12 col-md mr-auto d-flex justify-content-between flex-column flex-md-row'>
                <h1 className='txt-body txt-uppercase color-brand-2-like'>
                  Endereço de Entrega
                </h1>
                <p className='txt-body-sm'>{setLabel(stepOnMode)}</p>
              </div>
            </div>
            : <div className='row mx-0 align-items-center h-100'>
              <div className='col-10 mr-auto'>
                <h1 className='txt-body txt-uppercase color-ui-3'>
                  Endereço de Entrega
                </h1>
                <p className='txt-body-sm'>{`${address.street}, ${address.number} - ${address.complement}`}</p>
              </div>
              <div className='col-md-auto col-2 p-0'>
                <a
                  className='color-brand-2-like txt-body-sm txt-right txt-underline color-links border-color-links'
                  href='javascript:void(0)'
                  onClick={() => {
                    handleStep(1)
                    handleStepOnMode('edit')
                  }}>Alterar</a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  )
}

Header.propTypes = {
  step: PropTypes.number.isRequired,
  handleStep: PropTypes.func,
  handleStepOnMode: PropTypes.func,
  stepOnMode: PropTypes.string,
  address: PropTypes.object
}

export default Header



// WEBPACK FOOTER //
// ./src/features/LikePlus/Tabs/RequestCard/Address/Header.js